'use client';
import { YMMForm } from '@/components/molecules/YMM';
import { StyledContainer } from '@/ui-components/atoms/Layout/StyledContainer/StyledContainer';
import { YMMData } from '@/components/molecules/YMM/interfaces';
import { getYMMCookies, setYMMCookies } from '@/packages/sxm/ymm';
import { Platform } from '@/packages/sxm/ymm/types';
import { useState } from 'react';
import { Text } from '@/ui-components/atoms/Text/Text';

export default function VehicleFeaturesClient() {
    const [ymmData, setYmmData] = useState<YMMData>(() => {
        const carData = getYMMCookies().sxm_radio.split('|');
        return carData[1]
            ? { year: carData[1], make: carData[2], model: carData[3], id: carData[4] }
            : { year: '', make: '', model: '', id: '' };
    });

    function onCarReady(ymm: YMMData) {
        // Since the capabilities data might be from the previews vehicle or undefined we want to be sure the capabilities are from the same vehicle before updating.
        if (window && ymm && ymm.id === ymm.capabilities?.ymmComboId) {
            let platform: Platform = 'siriusxm';
            if (ymm && ymm.capabilities) {
                if (ymm.capabilities.siriusRadio) {
                    platform = 'sirius';
                } else if (ymm.capabilities.xmRadio) {
                    platform = 'xm';
                }
            }

            setYMMCookies({
                sxm_radio: `YMM|${ymm.year}|${ymm.make}|${ymm.model}|${ymm.id}`,
                sxm_platform: platform,
                inft_ymm: ymm.capabilities?.infotainment.join('|') || '',
                ymm_bar: '',
                roadblockbypass: '',
            });

            if (
                ymm.year !== ymmData.year ||
                ymm.make !== ymmData.make ||
                ymm.model !== ymmData.model ||
                ymm.id !== ymmData.id
            ) {
                setYmmData({
                    year: ymm.year,
                    make: ymm.make,
                    model: ymm.model,
                    id: ymm.id,
                });
                window.location.reload();
            }
        }
    }

    return (
        <>
            <StyledContainer paddingBottom={24}>
                <YMMForm theme="evenly-spaced" onCarReady={onCarReady} reset={true} />
            </StyledContainer>
            {ymmData.year && ymmData.make && (
                <Text tag="span" variant="h5" dataCy="contentful-asset-group-vehicle-features-ymm-text">
                    {ymmData.year} {ymmData.make} {ymmData.model}
                </Text>
            )}
        </>
    );
}
